import Color from 'color'

import type { NormalizedThemeOptions } from './types'

export function tenantTeaserImageSize(size?: NormalizedThemeOptions['teaserImageSize']): {
  width: number
  height: number
} {
  // Most tenants have teasers that are 272x216px, an aspect ratio of 4:5.
  const width = size?.width ?? 272
  const height = size?.height ?? 216
  return { width, height }
}

/**
 * Use when converting unknown string values into a Color object.
 */
export function parseColorString(value: string | undefined): Color<string> | undefined {
  try {
    return Color(value)
  } catch (e) {
    // Silently handle invalid color strings
    return undefined
  }
}

export function camelToKebabCase(s: string): string {
  return s.replace(/([A-Z0-9])/g, (w, _, i) => {
    return i === 0 ? w.toLowerCase() : `-${w.toLowerCase()}`
  })
}

/**
 * @deprecated Remove once `tg_seat_accessibility` has been cleaned up.
 */
export const ticketGroupColors = [
  'rgb(230, 25, 75)',
  'rgb(60, 180, 75)',
  'rgb(67, 99, 216)',
  'rgb(245, 130, 49)',
  'rgb(145, 30, 180)',
  'rgb(66, 212, 244)',
  'rgb(240, 50, 230)',
  'rgb(191, 239, 69)',
  'rgb(250, 190, 190)',
  'rgb(70, 153, 144)',
  'rgb(230, 190, 255)',
  'rgb(154, 99, 36)',
  'rgb(255, 250, 200)',
  'rgb(128, 0, 0)',
  'rgb(170, 255, 195)',
  'rgb(128, 128, 0)',
  'rgb(255, 216, 177)',
  'rgb(0, 0, 117)',
  'rgb(169, 169, 169)',
  'rgb(96, 125, 139)',
]

export const colorblindSafeTicketGroupColors = [
  '#746FB2',
  '#9651A0',
  '#C8008F',
  '#EE64A4',
  '#EE0220',
  '#008A25',
  '#795549',
  '#6F7C4D',
]

export const accessibleTicketGroupColor = '#009DE5'
